import React, { useState, useMemo } from 'react';
import { Collapse, FormGroup, Badge, ControlLabel, FormControl } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Translations from '../../../../../../../../components/Collapse/Translations';

import { getDefaultLanguage, getOtherLanguages } from './helper';
import * as types from '../../reducer/constants';

const ServiceName = ({ form, dispatchServiceData }) => {
  const { service_title } = form;

  const defaultLanguage = useMemo(() => getDefaultLanguage(service_title), [service_title]);
  const otherLanguages = useMemo(() => getOtherLanguages(service_title), [service_title]);

  const [open, setOpen] = useState(false);
  const onOpenTranslation = () => {
    setOpen(!open);
  };

  const onChange = (value, index) => {
    const serviceName = _.cloneDeep(service_title);
    serviceName[index].value = value;
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SERVICE_NAME, service_title: serviceName });
  };

  return (
    <>
      <FormGroup
        className={classNames({
          'form-group__rtl': defaultLanguage.direction === 'rtl',
        })}
      >
        <ControlLabel htmlFor={`service_name_${defaultLanguage.language_code}`}>
          Service name
          {' '}
          <Badge>{defaultLanguage.language_name}</Badge>
        </ControlLabel>
        <Translations onOpen={onOpenTranslation} open={open} items={service_title}>
          <FormControl
            type="text"
            id={`service_name_${defaultLanguage.language_code}`}
            name={`name-${defaultLanguage.language_code}`}
            value={defaultLanguage.value || ''}
            onChange={(e) => onChange(e.target.value, 0)}
            required
          />
        </Translations>
      </FormGroup>
      {otherLanguages.length ? (
        <Collapse in={open}>
          <div>
            {otherLanguages.map((language, index) => {
              const { language_name, language_code, direction, value } = language;
              return (
                <FormGroup
                  key={index}
                  className={classNames({
                    'form-group__rtl': direction === 'rtl',
                  })}
                >
                  <ControlLabel htmlFor={`service_name_${language_code}`}>
                    Service name
                    {' '}
                    <Badge>{language_name}</Badge>
                  </ControlLabel>
                  <FormControl
                    type="text"
                    id={`service_name_${language_code}`}
                    name={`name-${language_code}`}
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value, index + 1)}
                  />
                </FormGroup>
              );
            })}
          </div>
        </Collapse>
      ) : null}
    </>
  );
};

ServiceName.propTypes = {
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
};

export default ServiceName;
